import { useEffect } from 'react';

function useBeforeUnload({ subscribe = true } = {}) {
  useEffect(() => {
    const onBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = ''; // eslint-disable-line no-param-reassign
    };

    if (subscribe) window.addEventListener('beforeunload', onBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
    };
  }, [subscribe]);
}

export default useBeforeUnload;
